/**
 * Maps semantic auth-cookie names to the short suffix used in the actual cookie name on the wire.
 * Refresh and access entries point at expiration tokens, since the real refresh/access cookies are
 * `httpOnly` and not readable from JS.
 * @category Utils
 */
export const cookiesPostfix = {
  Mock: 'mk',
  Login: 'li',
  LoginWithAmazon: 'LWA_li',
  Refresh: 'refresh_exp', // use expiration token because refresh cookie is http-only
  Access: 'access_exp', // use expiration token because access cookie is http-only
  Employee: 'emp' // by employee here we mean an employee which is logged in by poslogon
}
